import { render, staticRenderFns } from "./ManageParameters.vue?vue&type=template&id=39373a2d&"
import script from "./ManageParameters.vue?vue&type=script&lang=js&"
export * from "./ManageParameters.vue?vue&type=script&lang=js&"
import style0 from "./ManageParameters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports